import { Badge } from "./Badge"
import { INVITE_STATUS, INVITE_STATUS_LABELS } from "../constants/inviteStatus"

export const InviteStatusBadge = ({ status = INVITE_STATUS.PENDING, width = "w-32", ...props }) => {
  const variant =
    status === INVITE_STATUS.ACCEPTED
      ? "success"
      : status === INVITE_STATUS.PENDING
        ? "waiting"
        : status === INVITE_STATUS.CANCELLED
          ? "error"
          : "secondary"

  return <Badge variant={variant} text={INVITE_STATUS_LABELS[status]} width={width} {...props} />
}
